<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('notificationManual.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('notificationManual.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4">
            <ts-button color="info" outline @click="createForm()">
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-8 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 300px"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'main_program.acp_name_foreign',
          }"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.branch.branch_name_en }}
            </td>
            <td>{{ record.not_subject }}</td>
            <td class="ts-whitespace-no-wrap">
              <div
                v-if="
                  record.msg_content ? record.msg_content.length < 45 : true
                "
              >
                {{ record.msg_content }}
              </div>
              <div v-tooltip="record.msg_content" v-else>
                {{ record.msg_content.substring(0, 45) + '...' }}
              </div>
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.modified_date }}</td>
            <td class="ts-whitespace-no-wrap">
              <span
                v-for="(item, index) in record.receiver_type.split(',')"
                :key="index"
              >
                <span class="badge badge-primary mr-1" v-if="item == 1"
                  {{ $t('notificationmanual.parent') }}></span
                >
                <span class="badge badge-warning mr-1" v-if="item == 2"
                  >{{ $t('notificationmanual.student') }}</span
                >
                <span class="badge badge-success mr-1" v-if="item == 3"
                  >{{ $t('notificationmanual.staff') }}</span
                >
                <span class="badge badge-info" v-if="item == 5">{{ $t('notificationmanual.teacher') }}</span>
              </span>
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              <span class="badge badge-success mr-1" v-if="record.mobile"
                >{{ $t('notificationmanual.mobile') }}</span
              >
              <span class="badge badge-primary mr-1" v-if="record.email"
                >{{ $t('notificationmanual.email') }}</span
              >
              <span class="badge badge-green" v-if="record.sms">{{ $t('notificationmanual.sms') }}</span>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
    <!-- drawer -->
    <a-drawer
      :title="$t('invoice.filter')"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="() => (visible = false)"
      :zIndex="1020"
      width="300px"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <ts-branch-filter @filter="(value) => (branch_id = value)" />

         </div>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './create'
export default {
  name: 'notification-manual',
  data() {
    return {
      loading: false,
      visible: false,
      branchs: []

    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('notificationManual', ['resources', 'pagination']),
    columns() {
      return [
        {
          name: this.$t('notificationManual.branch'),
          sortKey: 'branch.branch_name_en',
        },
        {
          name: this.$t('notificationManual.subject'),
          sortKey: 'not_subject',
        },
        {
          name: this.$t('notificationManual.content'),
        },
        {
          name: this.$t('notificationManual.date'),
        },
        {
          name: this.$t('notificationManual.deliveredTo'),
        },
        {
          name: this.$t('notificationManual.receiverType'),
          style: 'text-align:center',
        },
      ]
    },
    search: {
      get() {
        return this.$store.state.notificationManual.search
      },
      set(newValue) {
        this.$store.commit('notificationManual/SET_SEARCH', newValue)
        this.$store.commit('notificationManual/RESET_CURRENT_PAGE')
      },
    },
   
  },
  methods: {
    createForm(data) {
      this.$modal.show(
        FormComponent,
        {
          data: data,
        },
        {
          height: 'auto',
          width: '70%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false,
        },
        {
          'before-close': this.fetchData,
        }
      )
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'notificationManual/fetch',
          Object.assign(
            {
              branch_id: this.branch_id,
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch((errors) => {
          this.loading = false
          this.$toasted.error(errors.message)
        })
    },
    
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search, branch_id: this.branch_id })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('notificationManual/RESET_STATE')
    next()
  },
}
</script>
